<template>
  <div class="setting-info">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <div class="class-form-head">报名设置</div>
      <FormItem label="报名开始时间" prop="enrollTimeBegin">
        <DatePicker
          :value="formValidate.enrollTimeBegin"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          clearable
          class="class-form-item"
          :options="beginDateOption"
          @on-change="handleGetEndTime($event, 'enrollTimeBegin')"
        ></DatePicker>
      </FormItem>
      <FormItem label="报名截止时间" prop="enrollTimeEnd">
        <DatePicker
          :value="formValidate.enrollTimeEnd"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          clearable
          class="class-form-item"
          :options="endDateOption"
          @on-change="handleGetEndTime($event, 'enrollTimeEnd')"
        ></DatePicker>
      </FormItem>
      <div class="class-form-head">退款设置</div>
      <FormItem label="退款申请许可" prop="enableRefund">
        <RadioGroup v-model="formValidate.enableRefund">
          <Radio label="0">不允许</Radio>
          <Radio label="1">允许</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem v-if="formValidate.enableRefund == 1" label="退款截止时间" prop="refundDeadLine">
        <DatePicker
          :value="formValidate.refundDeadLine"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择时间"
          clearable
          class="class-form-item"
          :options="endDateOption"
          @on-change="handleGetEndTime($event, 'refundDeadLine')"
        ></DatePicker>
      </FormItem>
      <FormItem label="退款商品选择设置" prop="refundConfig">
        <RadioGroup v-model="formValidate.refundConfig">
          <Radio label="1">套餐内课程需一并发起退款</Radio>
          <Radio label="0">套餐内课程可单独发起退款</Radio>
        </RadioGroup>
      </FormItem>
      <div class="class-form-head">其他设置</div>
      <FormItem label="发布后上架" prop="classroomState">
        <RadioGroup v-model="formValidate.classroomState">
          <Radio :label="4">上架</Radio>
          <Radio :label="0">不上架</Radio>
        </RadioGroup>
        <p>若设置不上架，则在家长端选课列表中不展示本课程</p>
      </FormItem>
      <div class="class-form-head">课程套餐介绍</div>
      <FormItem label="套餐封面" prop="">
        <UploadBtn
          :text="`选择封面`"
          class="upload"
          :upload-type="1"
          :accept="`image/*`"
          @on-success="handleUploadImg"
        ></UploadBtn>
        <div v-if="imgFile.localUrl" class="cover-main">
          <Icon
            type="ios-close"
            size="30"
            class="delBtn"
            @click="handleDelCover"
          ></Icon>
          <img class="cover-img" :src="imgFile.localUrl">
        </div>
        <p>
          建议尺寸750*560，小于5M的JPG、PNG格式图片，若不上传，则随机截取其中一个商品课程封面
        </p>
      </FormItem>
      <FormItem label="课程套餐介绍" prop="packageDesc">
        <Editor ref="editorRef" @on-create="onEditorCreate"></Editor>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { formatTime } from '@/utils/utils';
import UploadBtn from '@c/UploadBtn';
import Editor from '@c/Base/Editor';
import { readFileOfImage, getGradeMinAndMax } from '@/utils/utils';
import { compressPic } from '@/utils/imageHelper';
import axios from 'axios';
export default {
  components: {
    UploadBtn,
    Editor
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => null
    }
  },
  data() {
    const validateEndDateTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择报名截止时间'));
      } else if (this.formValidate.enrollTimeBegin && new Date(this.formValidate.enrollTimeBegin).valueOf() >= new Date(value).valueOf()) {
        callback(new Error('报名截止时间不能小于报名开始时间'));
      } else {
        callback();
      }
    };
    const validaterefundDeadline = (rule, value, callback) => {
      if (this.formValidate.enableRefund == 1 && !value) {
        callback(new Error('请选择退款截止时间'));
      } else {
        callback();
      }
    };
    return {
      ruleValidate: {
        enrollTimeBegin: [
          { required: true, message: '请选择报名开始时间', trigger: 'change' }
        ],
        enrollTimeEnd: [
          { required: true, validator: validateEndDateTime, trigger: 'change' }
        ],
        refundDeadLine: [
          { validator: validaterefundDeadline, trigger: 'change' }
        ],
        classroomState: [
          { type: 'number', required: true, message: '请设置上架状态', trigger: 'change' }
        ],
        packageDesc: [
          { type: 'string', required: true, message: '请输入课程套餐介绍', trigger: 'change' }
        ],
        refundConfig: [
          { type: 'string', required: true, message: '请选择退款商品选择设置', trigger: 'change' }
        ],
        enableRefund: [
          { type: 'string', required: true, message: '请选择退款申请是否许可', trigger: 'change' }
        ]
      },
      enrollTimeEnd: '',
      refundDeadLine: '',
      formValidate: {
        enrollTimeBegin: '',
        enrollTimeEnd: '',
        refundDeadLine: '',
        enableRefund: '1',
        classroomState: 0,
        packageDesc: '',
        refundConfig: '1'

      },
      UploadUrl: '',
      uploadToken: '',
      downloadUrl: '',
      courseCover: null,
      // 设置不可选时间
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      imgFile: {
        localUrl: '',
        file: '',
        type: 2 // 1: 后端返回，2:源文件
      },
      descEditor: null
    };
  },
  computed: {
    beginDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.formValidate.enrollTimeEnd) {
            status = date && date.valueOf() < new Date(that.formValidate.enrollTimeEnd).valueOf();
          }
          return !status;
        }
      };
    },
    endDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          const nowTime = Date.now();
          const beginTime = that.formValidate.enrollTimeBegin ? new Date(that.formValidate.enrollTimeBegin).valueOf() : '';
          const line = beginTime;

          status = date && date.valueOf() > line - 24 * 60 * 60 * 1000;
          return !status;
        }
      };
    }
  },
  watch: {

    detailInfo(newVal) {
      this.fillForm(newVal);
    }
  },
  created() {
    const datestr = formatTime(Date.now(), 'yyyy-MM-dd hh:mm:ss');
    this.$set(this.formValidate, 'enrollTimeBegin', datestr);
  },
  mounted() {

  },
  methods: {
    onEditorCreate() {

    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    async handleCheckSubmit(name) {
      return new Promise(async(resolve, reject) => {
        this.formValidate.packageDesc = this.$refs.editorRef.getEditorContext();
        this.$nextTick(() => {
          this.$refs['formValidate'].validate((valid) => {
            if (valid) {
              resolve();
            } else {
              if (!this.formValidate.enrollTimeEnd) {
                this.$Message.warning('请选择报名截止时间');
                return null;
              }
              if (+this.formValidate.enableRefund === 1 && !this.formValidate.refundDeadLine) {
                this.$Message.warning('请选择退款截止时间');
                return null;
              }
              if (!this.formValidate.packageDesc) {
                this.$Message.warning('请输入课程套餐介绍');
                return null;
              }
            }
          });
        });
      });
    },
    async fillForm(info) {
      this.formValidate.enrollTimeBegin = info.enrollTimeBegin;
      this.formValidate.enrollTimeEnd = info.enrollTimeEnd;
      this.formValidate.refundDeadLine = info.refundDeadLine;
      this.formValidate.classroomState = info.classroomState;
      this.enrollTimeEnd = info.enrollTimeEnd;
      this.refundDeadLine = info.refundDeadLine;
      this.formValidate.packageDesc = info.packageDesc;
      this.formValidate.courseCover == info.courseCover;
      this.formValidate.enableRefund = String(info.enableRefund);
      this.formValidate.refundConfig = String(info.refundConfig);
      //
      setTimeout(() => {
        this.$refs.editorRef.setEditorContext(info.packageDesc);
      }, 1000);
      await this.getUploadtoken();
      this.imgFile = {
        localUrl: !this.formValidate.courseCover ? '' : this.downloadUrl + '?fileId=' + this.formValidate.courseCover,
        file: '',
        type: 1 // 1: 后端返回，2:源文件
      };
    },
    handleGetEndTime(time, key) {
      this.formValidate[key] = time;
    },
    async getParameter() {
      return new Promise(async(resolve, reject) => {
        const { classroomState, enrollTimeEnd, enrollTimeBegin, refundDeadLine, refundConfig, enableRefund } = this.formValidate;
        if (!this.imgFile.localUrl) {
          this.formValidate.courseCover = '';
        }
        if (this.imgFile.type == 2 && this.imgFile.file) {
          await this.getUploadtoken();
          this.formValidate.courseCover = await this.uploadImg(
            this.imgFile.file
          );
        }
        const params = {
          enrollTimeEnd, classroomState, enrollTimeBegin, packageDesc: this.$refs.editorRef.getEditorContext(), enableRefund, refundConfig,
          courseCover: this.formValidate.courseCover
        };
        if (+enableRefund === 1) {
          params.refundDeadLine = refundDeadLine;
        }

        resolve(params);
      });
    },
    handleUploadImg(files) {
      this.getBase64Img(files);
      console.log(files[0]);
    },
    handleDelCover() {
      this.imgFile.localUrl = '';
      this.imgFile.file = '';
    },
    async getBase64Img(files) {
      const file = files[0];
      const fileSize = file.size;
      try {
        const result = await readFileOfImage(file);
        let yaImageStr = ''; // 压缩后的base64图片
        // 如果图片大小大于200k,先进行压缩
        if (Math.round(fileSize / 1024) > 200) {
          yaImageStr = await compressPic(result, {
            quality: 0.7
          });
        } else {
          yaImageStr = result;
        }
        this.imgFile = {
          localUrl: yaImageStr,
          file: file,
          type: 2 // 1: 后端返回，2:源文件
        };
      } catch (error) {
        console.log(error);
        this.$Message.warning('读取图片失败');
      }
    },

    // 上传图片
    async uploadImg(ev) {
      return new Promise(async(resolve, reject) => {
        const file = ev;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
              const val = (
                (progressEvent.loaded / progressEvent.total) *
                100
              ).toFixed(0);
              this.uploadPersent = parseInt(val);
            }
          },
          cancelToken: this.source.token
        };

        axios
          .post(this.UploadUrl, formData, configs)
          .then(res => {
            if (res.data.status === 200) {
              const id = res.data.message.fileId;

              resolve(id);
            } else {
              this.$Spin.hide();
              reject(res.data.error);
              this.$Message.warning(res.data.error);
            }
          })
          .catch(err => {
            if (err.message) {
              this.$Message.error(err.message);
            }
          })
          .finally(() => { });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cover-main {
  width: 168px;
  height: 168px;
  padding: 8px;
  position: relative;
  .delBtn {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    color: #fff;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
